// NSTONE TYPES

export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SET_USER_TYPE = 'SET_USER_TYPE'
export const EDIT_NEXT_PROJECT = 'EDIT_NEXT_PROJECT'
export const SET_UPLOAD_FILE = 'SET_UPLOAD_FILE'
export const SET_DEVICE_SCREEN_SIZE = 'SET_DEVICE_SCREEN_SIZE'
export const CHANGE_MENU_STATE = 'CHANGE_MENU_STATE'
export const SELECT_MATERIAL_TYPE = 'SELECT_MATERIAL_TYPE'
export const UPDATE_FILTER = 'UPDATE_FILTER'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const SET_PROJECTS = 'SET_PROJECTS'
export const LOAD_MORE = 'LOAD_MORE'
export const UPDATE_PROJECTS_LIST = 'UPDATE_PROJECTS_LIST'
export const UPDATE_PAGE_NEXT_PAGE = 'UPDATE_PAGE_NEXT_PAGE'
export const UPDATE_FILTER_DISTANCE = 'UPDATE_FILTER_DISTANCE'
export const UPDATE_FILTER_NAME = 'UPDATE_FILTER_NAME'
export const UPDATE_FILTER_TYPE = 'UPDATE_FILTER_TYPE'
export const UPDATE_FILTER_DATE = 'UPDATE_FILTER_DATE'
export const UPDATE_FILTER_DATE_ADMIN = 'UPDATE_FILTER_DATE_ADMIN'
export const UPDATE_FILTER_PROJECTS_ADMIN = 'UPDATE_FILTER_PROJECTS_ADMIN'
export const UPDATE_NEW_PROJECT = 'UPDATE_NEW_PROJECT'
export const UPDATE_COMPETITION_CHANGE = 'UPDATE_COMPETITION_CHANGE'
export const UPDATE_MY_COMPETITIONS_FILTER_TYPE = 'UPDATE_MY_COMPETITIONS_FILTER_TYPE'
export const UPDATE_USER_FIELDS = 'UPDATE_USER_FIELDS'
export const REMOVE_ACCEPTED_PROJECT = 'REMOVE_ACCEPTED_PROJECT'
export const PUSH_ROUTES = 'PUSH_ROUTES'
export const PUSH_USER_ROUTES = 'PUSH_USER_ROUTES'
export const CLEAR_RESUME_FILTER_DATES = 'CLEAR_RESUME_FILTER_DATES'
export const SET_MARBLES_USER = 'SET_MARBLES_USER'
export const LOAD_MORE_MARBLES = 'LOAD_MORE_MARBLES'
export const LOAD_MORE_PROJECTS_ADMIN = 'LOAD_MORE_PROJECTS_ADMIN'
export const UPDATE_MARBLES_NEXT_PAGE = 'UPDATE_MARBLES_NEXT_PAGE'
export const UPDATE_PROJECTS_NEXT_PAGE = 'UPDATE_PROJECTS_NEXT_PAGE'
export const UPDATE_ADMIN_MARBLE_STATE = 'UPDATE_ADMIN_MARBLE_STATE'
export const UPDATE_ADMIN_PROJECT_STATE = 'UPDATE_ADMIN_PROJECT_STATE'
export const UPDATE_COMPETITORS_QUANTITY = 'UPDATE_COMPETITORS_QUANTITY'
export const ADMIN_MARBLES_NAME = 'ADMIN_MARBLES_NAME'
export const ADMIN_PROJECTS_NAME = 'ADMIN_PROJECTS_NAME'
export const UPDATE_MARBLES_PLANS = 'UPDATE_MARBLES_PLANS'
export const UPDATE_MARBLES_IN_PROJECTS = 'UPDATE_MARBLES_IN_PROJECTS'
export const CLEAR_FILTER_MARBLES_ADMIN = 'CLEAR_FILTER_MARBLES_ADMIN'
export const CLEAR_FILTER_PROJECTS_ADMIN = 'CLEAR_FILTER_PROJECTS_ADMIN'
export const SET_PROJECTS_ADMIN = 'SET_PROJECTS_ADMIN'
export const SET_NOTIFICATIONS_VIEW = 'SET_NOTIFICATIONS_VIEW'
export const SET_NOTIFICATIONS_NOT_VIEW = 'SET_NOTIFICATIONS_NOT_VIEW'
export const UPDATE_NOTIFICATIONS_NOT_VIEW = 'UPDATE_NOTIFICATIONS_NOT_VIEW'
export const UPDATE_NOTIFICATIONS_VIEW = 'UPDATE_NOTIFICATIONS_VIEW'
export const SET_NOTIFICATIONS_TO_READ = 'SET_NOTIFICATIONS_TO_READ'
export const UPDATE_NOTIFICATIONS_LIST_VIEW = 'UPDATE_NOTIFICATIONS_LIST_VIEW'
export const SET_NEW_NOTIFICATION = 'SET_NEW_NOTIFICATION'

// NANOPRICE TYPES

// SNACK BAR
export const DISPLAY_SNACK = 'DISPLAY_SNACK'
export const HIDE_SNACK = 'HIDE_SNACK'
export const SET_SELECTED_MATERIAL_TYPE = 'SET_SELECTED_MATERIAL_TYPE'
export const SELECTED_MATERIAL_TYPE = 'SELECTED_MATERIAL_TYPE'
export const SELECTED_TYPE = 'SELECTED_TYPE'
export const SELECTED_ALL_TYPE = 'SELECTED_ALL_TYPE'
export const SELECT_COLOR = 'SELECT_COLOR'
export const SELECT_APPLICATION = 'SELECT_APPLICATION'
export const SELECT_MATERIAL = 'SELECT_MATERIAL'
export const SELECT_FINISH = 'SELECT_FINISH'
export const SET_PRICE = 'SET_PRICE'
export const CLEAR_FILTERS = 'CLEAR_FILTERS'
export const SET_TO_COMPARE_MATERIAL = 'SET_TO_COMPARE_MATERIAL'
export const REMOVE_COMPARABLE_MATERIAL = 'REMOVE_COMPARABLE_MATERIAL'
export const REMOVE_ALL_MATERIALS_FROM_COMPARATOR = 'REMOVE_ALL_MATERIALS_FROM_COMPARATOR'
export const SET_MATERIAL_LIST = 'SET_MATERIAL_LIST'
export const SET_SCROLL_PAGE_POINT = 'SET_SCROLL_PAGE_POINT'
export const RESET_SCROLL_POINT = 'RESET_SCROLL_POINT'
export const SET_INITIAL_FILTER = 'SET_INITIAL_FILTER'
export const REFETCH_MATERIAL = 'REFETCH_MATERIAL'
export const SET_PROJECT_NAME = 'SET_PROJECT_NAME'
export const SET_PROJECT_EMAIL = 'SET_PROJECT_EMAIL'
export const PLUS_MINUS_SELECT = 'PLUS_MINUS_SELECT'
export const CREATE_AMBIENTES = 'CREATE_AMBIENTES'
export const SET_PROJECT_MATERIALS = 'SET_PROJECT_MATERIALS'
export const UNSET_PROJECT_MATERIALS = 'UNSET_PROJECT_MATERIALS'
export const SET_STEP_DONE = 'SET_STEP_DONE'
export const SELECT_AMBIENT_EDIT = 'SELECT_AMBIENT_EDIT'
export const REMOVE_PROJECT_AMBIENT = 'REMOVE_PROJECT_AMBIENT'
export const DELETE_PROJECT_AMBIENT = 'DELETE_PROJECT_AMBIENT'
export const DELETE_PROJECT_AMBIENT_NOT_COMPLETED = 'DELETE_PROJECT_AMBIENT_NOT_COMPLETED'
export const UPDATE_CURRENT_PROJECT = 'UPDATE_CURRENT_PROJECT'
export const START_PROJECT = 'START_PROJECT'
export const SET_ITEM_AS_SELECTED = 'SET_ITEM_AS_SELECTED'
export const SET_ITEM_AS_UNSELECTED = 'SET_ITEM_AS_UNSELECTED'
export const FROM_COMPARATOR_NATERIALS = 'FROM_COMPARATOR_NATERIALS'
export const SET_FROM_COMPARATOR_NATERIALS = 'SET_FROM_COMPARATOR_NATERIALS'
export const GOT_IN_MOODBOARD = 'GOT_IN_MOODBOARD'
export const SET_MARBLES_MAP = 'SET_MARBLES_MAP'
export const SET_RANGE_MAP = 'SET_RANGE_MAP'
export const SET_MAP_STATE = 'SET_MAP_STATE'
export const SET_MAP_CEP = 'SET_MAP_CEP'
export const LOAD_MORE_MAPS = 'LOAD_MORE_MAPS'
export const SET_UNLOCKED_DATA = 'SET_UNLOCKED_DATA'
export const CLEAR_SELECTED_STATE = 'CLEAR_SELECTED_STATE'
export const PROJECT_WAS_SENT = 'PROJECT_WAS_SENT'
export const SET_PROJECT_CODE = 'SET_PROJECT_CODE'
export const SET_USER_FORM = 'SET_USER_FORM'
export const SET_MATERIAL_FORM = 'SET_MATERIAL_FORM'
export const REMOVE_UPLOAD = 'REMOVE_UPLOAD'
export const SET_PROJECT_DETAILS = 'SET_PROJECT_DETAILS'
export const CLEAR_STATE = 'CLEAR_STATE'